var render, staticRenderFns
import script from "./PostingSuppliersListPrototype.vue?vue&type=script&lang=js&"
export * from "./PostingSuppliersListPrototype.vue?vue&type=script&lang=js&"
import style0 from "./PostingSuppliersListPrototype.vue?vue&type=style&index=0&id=4988f85e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4988f85e",
  null
  
)

export default component.exports